export const jqAccordionDropdown = () => {
	document.querySelectorAll(".content-page-accordion-dropdown-item-header").forEach((el) => {
		el.addEventListener("click", (e) => {
			e.stopPropagation();
			e.stopImmediatePropagation();
			e.target.classList.contains("toggle")
				? e.target.setAttribute("aria-expanded", "false")
				: e.target.setAttribute("aria-expanded", "true");
			e.target.classList.toggle("toggle");
		});
	});
};
